// NgRx reducers
import { combineReducers } from '@ngrx/store';
import { currentReportIndex, currentReportTypeIndex, customPdfReportMenu, reportMenuFetchRequest, } from './report-menu/report-menu.reducers';
import { currentWizardStepIndex } from './wizard-step/wizard-step.reducer';
import { reportTitle, selectedReport } from './selected-report/selected-report.reducer';
import { primarySecurity, secondarySecurity, comparisonSecurities, } from './report-securities/report-securities.reducers';
import { coverPageInfo, userPreferenceFetchRequest, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/cover-page/cover-page.reducers';
import { generatingReport, generationErrors, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/generate/generate.reducers';
import { compTableSecuritiesChoice, fundChartSecuritiesChoice, scatterPlotSecuritiesChoice, timeseriesTableSecuritiesChoice, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/saved-asset-securities-choices/saved-asset-securities-choices.reducer';
import { savedHypotheticalId } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/saved-hypothetical-id/saved-hypothetical-id.reducer';
import { talkingPoints } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/talking-points/talking-points.reducer';
import { namingConvention } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/naming-convention/naming-convention-reducer';
import { securityLevelValues } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/dollar-conversion-level-selector/dollar-conversion-level.reducer';
import { transitionAnalyses } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/transition_analyses/transition-analyses.reducer';
export const CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY = 'customPdfReportModal';
export const customPdfReportModal = combineReducers({
    comparisonSecurities,
    coverPageInfo,
    currentReportIndex,
    currentReportTypeIndex,
    currentWizardStepIndex,
    customPdfReportMenu,
    generatingReport,
    generationErrors,
    namingConvention,
    primarySecurity,
    reportMenuFetchRequest,
    reportTitle,
    savedHypotheticalId,
    secondarySecurity,
    selectedReport,
    talkingPoints,
    userPreferenceFetchRequest,
    fundChartSecuritiesChoice,
    scatterPlotSecuritiesChoice,
    compTableSecuritiesChoice,
    timeseriesTableSecuritiesChoice,
    securityLevelValues,
    transitionAnalyses,
});
